import { createMatchSelector } from 'connected-react-router';
import { connect } from 'react-redux';
import { pipe, path } from 'ramda';

import Content from 'components/RolePatient/ReportView/Content';
import {
  getReportItemAlert,
  getReportItemBatteryLife,
  getReportItemLastUpdated,
  getReportItemPacingValue,
  getReportItemStatus,
  getReportItemEffectiveDateTime,
  getFormatedReportItemShocks,
  getReportItemShockValue,
  getReportItemReviewDateTime,
  getReportItemReviewDate,
  getReportItemReviewTime,
  getReportItemTransmissionType,
} from 'store/selectors/reports/singleItems';
import { reportsMarkAsRead } from 'store/actionCreators/reports/singleItems';
import {
  getPatientClinicName,
  getPatientQuestionnaireResponseDeviceImplant,
} from 'store/selectors/patientQuestionnaireResponse';

const mapStateToProps = state => {
  const reportId = pipe(
    createMatchSelector('/report/:id'),
    path(['params', 'id']),
  )(state);

  return {
    alertValue: getReportItemAlert(reportId)(state),
    batteryLife: getReportItemBatteryLife(reportId)(state),
    clinicName: getPatientClinicName(state),
    deviceImplant: getPatientQuestionnaireResponseDeviceImplant(state),
    lastUpdated: getReportItemLastUpdated(reportId)(state),
    pacingValue: getReportItemPacingValue(reportId)(state),
    shocks: getFormatedReportItemShocks(reportId)(state),
    shockValue: getReportItemShockValue(reportId)(state),
    status: getReportItemStatus(reportId)(state),
    effectiveDateTime: getReportItemEffectiveDateTime(reportId)(state),
    isRead: !!getReportItemReviewDateTime(reportId)(state),
    readDate: getReportItemReviewDate(reportId)(state),
    readTime: getReportItemReviewTime(reportId)(state),
    transmissionType: getReportItemTransmissionType(reportId)(state),
  };
};

const mapDispatchToProps = {
  reportsMarkAsRead,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Content);
